import React, { Children } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function AuditionDetailsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
    </Grid>
  );
}

AuditionDetailsGrid.propTypes = {
  children: PropTypes.node,
};
